import type { ComponentType, PropsWithChildren } from 'react';
import type React from 'react';

import { TrackingContext } from '@change-corgi/core/react/tracking';

import type { ErrorStateDetails } from 'src/app/shared/utils/async';
import { isError, isLoaded } from 'src/app/shared/utils/async';

import type { LocationSitemapPageCombinedState, LocationSitemapPagePrefetchedContext } from './hook';
import { usePageContext } from './hook';
import { LocationSitemapPageDataContextProvider } from './pageData';

export type ErrorHandlerProps = { context: ErrorStateDetails<LocationSitemapPageCombinedState> };

type Props = {
	prefetchedData: LocationSitemapPagePrefetchedContext | undefined;
	errorHandler: ComponentType<ErrorHandlerProps>;
	loadingFallback: JSX.Element;
};

export const LocationSitemapPageContextProvider: React.FC<PropsWithChildren<Props>> = ({
	children,
	prefetchedData,
	errorHandler: ErrorHandler,
	loadingFallback,
}) => {
	const pageContextState = usePageContext(prefetchedData);

	if (isError(pageContextState)) {
		const { status, ...rest } = pageContextState;
		return <ErrorHandler context={rest} />;
	}
	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageData } = pageContextState;

	return (
		<LocationSitemapPageDataContextProvider pageData={pageData}>
			<TrackingContext properties={{}}>{children}</TrackingContext>
		</LocationSitemapPageDataContextProvider>
	);
};
